export const convertFileToBase64 = (file: File | null): Promise<string | ArrayBuffer | null> => {
    return new Promise((resolve, reject) => {
      if (!file) {
        resolve(null);
        return;
      }
      
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
      
      reader.readAsDataURL(file);
    });
  };

export const convertToImageSourceFromBase64 = (base64Photo: string, extension: string) => {
  return `data:image/${extension};base64,${base64Photo}`;
}

export const convertBase64ToFile = (base64data: string, fileNameWithExtension: string, contentType: string): File => {
    const byteCharacters = atob(base64data);

    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], fileNameWithExtension, {type: contentType});
}

export const convertImageFileToHtmlImage = (imageFile: File): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
        const htmlImage = new Image();
        htmlImage.src = URL.createObjectURL(imageFile);
        htmlImage.onload = () => {resolve(htmlImage)};
        htmlImage.onerror = error => reject(error);
    });
}